import type { IconData } from '@stacksjs/iconify-core'

export const otherUiLocation: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M8 16s7-3.5 7-9A7 7 0 1 0 1 7c0 5.5 7 9 7 9m0-7a2 2 0 1 0 0-4a2 2 0 0 0 0 4\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherUiLocation
